import React, { useState, useEffect } from "react";
import { TextField, Grid, Stack, Checkbox, Tooltip, Autocomplete, Box, Typography } from '@mui/material';
import _ from 'lodash';
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import DrawerBody from "rsuite/esm/Drawer/DrawerBody";
import CloseIcon from '@mui/icons-material/Close';
import { uploadSelector } from "../store/slices/upload";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { filterByValues } from "../common/utils";
import { getFileTypes } from "../common/utils";
import MultiSelectCheckboxDDL from './../common/multiselectCheckBoxDDL'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const getData = (users, accessUsers) => {
    let filteredUsers = filterByValues(users, 'CustomUserId', accessUsers)
    let fileData = _.map(filteredUsers, (user, index) => {
        return { label: user.Email, value: user.CustomUserId, hasCheckbox: true };
    });
    return fileData;
};

const FilterSideBar = ({ open, toggle, selectedUser, setSelectedUser, setSelectedTypes, selectedTypes }) => {
    const dispatch = useDispatch();
    const { users, accessUsers } = useSelector(uploadSelector);
    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    }));
    const usersData = React.useMemo(() => getData(users, accessUsers), [users, accessUsers]);
    const onChangeCheckbox = (accessor, isChecked) => {
        let newSelectedArray = [];
        const currentSelectedItems = _.cloneDeep(selectedTypes);
        if (isChecked) {
            if (_.find(currentSelectedItems, { value: accessor.value })) {

            }
            else {
                currentSelectedItems.push(accessor);
            }
        }
        else {
            if (_.find(currentSelectedItems, { value: accessor.value })) {
                _.remove(currentSelectedItems, { value: accessor.value })
            }
            else {
                //currentSelectedItems.push(home);
            }
        }

        setSelectedTypes(currentSelectedItems)
    }

    return (
        <Drawer
            sx={{
                width: 600,
                flexShrink: 0,
                //top:65
                '.MuiDrawer-paperAnchorDockedRight': {
                    top: 5,
                    height: 'calc(100vh - 10px)',
                    overflow: 'hidden',
                    width: '350px',
                },
            }}
            variant="persistent"
            anchor="right"
            open={open}
        >
            <DrawerHeader>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Stack
                        id="monthly_target_sb"
                        className="sidebar-header"
                        direction={"row"}
                        //justifyContent="space-"
                        alignItems={"center"}
                        spacing={2}
                    >
                        <div className="ir-fixed-modal-header" style={{ paddingLeft: 0 }}>
                            {/* <Typography className="modal-title">{selectedRow ? !isEdit ? 'Contact Details' : 'Edit Contact' : 'Add Contact'}</Typography> */}

                        </div>
                    </Stack>
                    {/* <Box sx={{ width: 320 }}></Box> */}
                    <Stack
                        direction={"row"}
                        //justifyContent="space-around"
                        //width={80}
                        alignItems={"center"}
                        spacing={2}
                        sx={{ marginRight: 1 }}
                    >
                        <div style={{ display: 'inline-flex', alignItems: 'center' }} >
                        </div>
                        <Tooltip title="Close" placement="top-start">
                            <CloseIcon sx={{ fontSize: '1rem' }} onClick={toggle}
                            />
                        </Tooltip>
                    </Stack>
                </Grid>
            </DrawerHeader>

            <DrawerBody>
                <Stack direction={'column'}>

                    {/* <Box sx={{ width: '500px', justifyContent: "space-between", display: "flex",marginTop:'30px'}}>      
        <div className="Dropdown-root" style={{ border: 'none',marginLeft:20 }}>
                                <MultiSelectCheckboxDDL
                                    title={_.map(selectedUser, 'label').join(', ')}
                                    value={selectedUser}
                                    maxWidth={300}
                                    width={300}
                                    minWidth={300}
                                    placeholder={'Select User...'}
                                    options={usersData}
                                    onChangeCallback={(response) => {setSelectedUser(response);}}
                                    oneCheckedAlways={true}
                                    selectFirstOnAllUnCheck={false}
                                    zIndex={801}
                                    optionListHeight={250}
                                     />
                            </div>
        
      </Box> */}
                    <Stack>

                        <Box mt={4}>
                            <Typography variant="h5" ml={1}>Types</Typography>
                            <Grid container direction={'row'}>
                                {getFileTypes().map((home, index) =>
                                    <Grid sm={6} key={index}>
                                        <Stack direction={'row'} sx={{ alignItems: 'center' }}>
                                            <Checkbox sx={{ padding: "4px" }} checked={_.find(selectedTypes, { value: home.value }) ?? false} onChange={(e) => { onChangeCheckbox(home, e.target.checked) }}></Checkbox>
                                            <div>{home.label}</div>
                                        </Stack>
                                    </Grid>
                                )}
                            </Grid>
                        </Box>

                    </Stack>
                </Stack>

            </DrawerBody>

        </Drawer>
    )
};

export default FilterSideBar;
